/**
 * フロントタブレット（セルフチェックイン・セルフチェックアウト）で共通利用する
 * フォームまわりのフォントサイズ・タイポグラフィ定数
 */
export const FrontTabletFontSize = {
  // フォーム入力値のフォントサイズ
  formInput: 22,
  // フォームのラベルのフォントサイズ
  formLabel: 20,
  // タイトルのフォントサイズ
  pageTitle: 22,
  // ラジオボタンのサイズ
  radio: 40,
  // ラジオボタン(mini)のサイズ
  radioMini: 30,
  // ラジオボタンのラベルのフォントサイズ
  radioLabel: 24,
  // ラジオボタン(mini)のラベルのフォントサイズ
  radioMiniLabel: 20,
  // フォームの文章のフォントサイズ
  text: 16,
} as const
